inputs.fn.search = {
    // Utilitaires et configuration partagés
    _searchUtils: {
        ignoredWords: ['de', 'a', 'des', 'du', 'le', 'la', 'les'],
        // Liste d'équivalences (synonymes / expansions)
        wordsEq: [
            // Entreprises / institutions majeures au Quebec
            ['rta', 'rio tinto'],
            ['hq', 'hydro quebec'],
            ['hydro', 'hydro quebec'],
            ['videotron', 'quebecor'],
            ['bnc', 'banque nationale du canada'],
            ['rbc', 'banque royale du canada'],
            ['bmo', 'banque de montreal'],
            ['td', 'banque toronto dominion'],
            ['cibc', 'banque imperiale du canada'],
            ['iga', 'iga'],
            ['provigo', 'loblaws'],

            // Tech & Internet
            ['google', 'goog'],
            ['google', 'alphabet'],
            ['facebook', 'fb'],
            ['facebook', 'meta'],
            ['amazon', 'amzn'],
            ['apple', 'aapl'],
            ['microsoft', 'msft'],
            ['tesla', 'tsla'],
            ['twitter', 'twtr'],
            ['linkedin', 'lnkd'],

            // Institutions publiques quebecoises
            ['saq', 'societe des alcools du quebec'],
            ['sq', 'surete du quebec'],
            ['stm', 'societe de transport de montreal'],
            ['stl', 'societe de transport de laval'],
            ['rtl', 'reseau de transport de longueuil'],
            ['exo', 'exo transport collectif'],
            ['uqam', 'universite du quebec a montreal'],
            ['uqtr', 'universite du quebec a trois-rivieres'],
            ['uqac', 'universite du quebec a chicoutimi'],
            ['uqo', 'universite du quebec en outaouais'],
            ['udes', 'universite de sherbrooke'],
            ['udem', 'universite de montreal'],
            ['hec', 'hec montreal'],
            ['ets', 'ecole de technologie superieure'],
            ['poly', 'polytechnique montreal'],
            ['cegep', 'college'],

            // Noms de lieux / directions
            ['saint', 'st'],
            ['ste', 'sainte'],
            ['sts', 'saints'],
            ['mt', 'mont'],
            ['mtl', 'montreal'],
            ['qbc', 'quebec'],
            ['qc', 'quebec'],
            ['ott', 'ottawa'],
            ['tor', 'toronto'],
            ['van', 'vancouver'],
            ['riv', 'riviere'],
            ['chl', 'charles'],
            ['chr', 'charles'],

            // Adresses
            ['rte', 'route'],
            ['ch', 'chemin'],
            ['av', 'avenue'],
            ['bd', 'boulevard'],
            ['blvd', 'boulevard'],
            ['pl', 'place'],
            ['sq', 'square'],
            ['all', 'allee'],
            ['imp', 'impasse'],
            ['pav', 'pavillon'],
            ['pk', 'parc'],
            ['ctr', 'centre'],
            ['ct', 'court'],

            // Entreprises / institutions
            ['inc', 'incorpore'],
            ['ltee', 'limitee'],
            ['lte', 'limite'],
            ['corp', 'corporation'],
            ['cie', 'compagnie'],
            ['co', 'compagnie'],
            ['ent', 'entreprise'],
            ['societe', 'societe'],
            ['soc', 'societe'],
            ['assoc', 'association'],
            ['org', 'organisation'],
            ['adm', 'administration'],
            ['min', 'ministere'],
            ['dep', 'departement'],
            ['dept', 'departement'],
            ['dir', 'direction'],

            // Divers généraux
            ['coop', 'cooperative'],
            ['assoc', 'association'],
            ['club', 'club sportif'],
            ['fond', 'fondation'],
            ['org', 'organisation'],
            ['sect', 'secteur'],
            ['div', 'division'],

            // Organisation / structure
            ['organisation', 'assoc'],
            ['association', 'club'],
            ['cooperative', 'coop'],
            ['fondation', 'fond'],
            ['societe', 'entreprise'],
            ['groupe', 'division'],
            ['division', 'secteur'],
            ['departement', 'section'],
            ['section', 'unite'],

            // Provinces canadiennes
            ['qc', 'quebec'],
            ['on', 'ontario'],
            ['mb', 'manitoba'],
            ['sk', 'saskatchewan'],
            ['ab', 'alberta'],
            ['bc', 'colombie-britannique'],
            ['ns', 'nouvelle-ecosse'],
            ['nb', 'nouveau-brunswick'],
            ['pe', 'ile-du-prince-edouard'],
            ['nl', 'terres-neuve-labrador'],

            // Titres / personnes
            ['dr', 'docteur'],
            ['mme', 'madame'],
            ['mlle', 'mademoiselle'],
            ['mr', 'monsieur'],
            ['pr', 'professeur'],

            // Academique / technique
            ['univ', 'universite'],
            ['poly', 'polytechnique'],
            ['cegep', 'college'],
            ['tech', 'technologie'],
            ['sci', 'science'],
            ['eng', 'engineering'],
            ['info', 'informatique'],
            ['med', 'medical'],
            ['pharm', 'pharmacie'],

            // Symboles
            ['♥', 'coeur'],
            ['&', 'et'],
            ['+', 'plus'],
            ['@', 'arobase'],
            ['#', 'numero'],
            ['%', 'pourcent'],
            ['$', 'dollar'],
            ['€', 'euro'],
            ['°', 'degre'],
            ['→', 'vers'],

            // Divers utiles
            ['tel', 'telephone'],
            ['no', 'numero'],
            ['nº', 'numero'],
            ['int', 'international'],
            ['nat', 'national'],
            ['prov', 'province'],
            ['fed', 'federal'],
            ['gov', 'gouvernement'],
            ['mun', 'municipal'],
            ['hist', 'historique'],
            ['cult', 'culturel'],
            ['comm', 'commerce'],
            ['ind', 'industrie'],
        ],

        // Normalize et standardize le texte (lowercase + suppression diacritiques + tirets considérés comme des espaces sauf si entourés de chiffres)
        normalizeText(str) {
            if (!str && str !== '') return '';
            return String(str).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                .replace(/(?<!\d)-|-(?!\d)/g, ' ')
                .trim();
        },

        // Construire les termes de recherche à partir d'une entrée utilisateur
        buildSearchTerms(rawVal) {
            const val = this.normalizeText(rawVal || '');
            if (!val) return [];
            let terms = val.split(/\s+/).filter((term) => term.length > 1 && this.ignoredWords.indexOf(term) === -1);

            // Expand with synonyms (wordsEq)
            terms = terms.flatMap((term) => {
                for (const eq of this.wordsEq) {
                    if (eq.includes(term)) {
                        // retourne toutes les variantes de cette paire (ou tuple)
                        return eq;
                    }
                }
                return term;
            });

            // Normaliser tous les termes (au cas où synonyms contiennent majuscules/diacritiques)
            terms = terms.map((t) => this.normalizeText(t));
            // Remove duplicates preserving order
            const seen = new Set();
            return terms.filter((t) => {
                if (seen.has(t)) return false;
                seen.add(t);
                return true;
            });
        },

        // Retourne un score (nombre de mots trouvés) pour un texte donné et des searchTerms
        matchTextAgainstTerms(text, searchTerms) {
            if (!searchTerms || searchTerms.length === 0) return 0;
            text = this.normalizeText(text || '');
            let score = 0;

            searchTerms.forEach((term) => {
                if (Array.isArray(term)) {
                    // if term is array (shouldn't happen after buildSearchTerms but support anyway)
                    for (const t of term) {
                        if (t && text.includes(this.normalizeText(t))) {
                            score++;
                            break;
                        }
                    }
                } else if (term && text.includes(term)) {
                    score++;
                }
            });

            return score;
        },

        // Matcher récursif pour Select2 (retourne data ou null)
        select2MatchRecursive(params, data, searchTerms) {
            // if empty search -> return as-is
            const term = (params && params.term) ? String(params.term).trim() : '';
            if (!term) {
                return data;
            }

            // If group
            if (data.children && data.children.length > 0) {
                const groupLabel = this.normalizeText(data.text || '');
                // If the group label itself matches -> return entire group
                if (this.matchTextAgainstTerms(groupLabel, searchTerms) > 0) {
                    return data;
                }

                // Otherwise try children
                const matchedChildren = [];
                for (const child of data.children) {
                    const childMatch = this.select2MatchRecursive(params, child, searchTerms);
                    if (childMatch != null) {
                        matchedChildren.push(childMatch);
                    }
                }

                if (matchedChildren.length > 0) {
                    // clone data shallowly and replace children
                    const modified = $.extend({}, data, true);
                    modified.children = matchedChildren;
                    return modified;
                }

                return null;
            }

            // Leaf node: test the text
            let nodeText = data.text || '';
            if (data.search) {
                nodeText += ' ' + data.search;
            }
            if (this.matchTextAgainstTerms(nodeText, searchTerms) > 0) {
                return data;
            }

            return null;
        },
    },

    // Fonction principale existante (filtre du DOM pour ton tableau)
    filter(data, name, niceName, type, input, parent, inputWindow, event) {
        if (data.target) {
            const valRaw = input.val();
            const utils = inputs.fn.search._searchUtils;
            const val = utils.normalizeText(valRaw);
            let target = inputWindow.find('[data-id="' + data.target + '"]');
            if (!target.length) target = inputWindow.find(data.target);
            const table = target.is('.table') ? target : target.find('.table');
            const items = target.find('.table__row').not('.table__row--no-results');

            // Build shared searchTerms once
            const searchTerms = utils.buildSearchTerms(valRaw);

            const pertinanceKeywords = ['Résultats les plus pertinants', 'Résultats pertinants', 'Pertinance négligeable', 'Un possible lien', 'Peu pertinant', 'Probablement aucun rapport', 'Définitivement aucun rapport', 'Combien de mots contient votre recherche déjà ?', 'Si vous voyez ce message, vous méritez un diplôme pour vos recherches complexes'];
            const pertinanceScores = [];
            let matchCount = 0;

            items.each(function () {
                const item = $(this);
                let itemText = item.text() || '';
                const itemSearch = item.data('search') || item.attr('search');
                if (itemSearch) {
                    itemText += ' ' + itemSearch;
                }
                // compute score using central function
                let matchWords = 0;

                if (!val) {
                    item.show();
                } else {
                    matchWords = inputs.fn.search._searchUtils.matchTextAgainstTerms(itemText, searchTerms);

                    if (matchWords > 0) {
                        item.show();
                        matchCount++;
                    } else {
                        item.hide();
                    }
                }

                pertinanceScores.push({
                    item,
                    score: matchWords,
                });
            });

            // Sort items by pertinence score in descending order
            pertinanceScores.sort((a, b) => b.score - a.score);

            // Apply order based on score
            pertinanceScores.forEach((entry, index) => {
                $(entry.item).css('order', index);
                // labels/commentaires peuvent être ajoutés ici si besoin
                // const pertinanceLevel = Math.min(entry.score, pertinanceKeywords.length - 1);
                // entry.item.find('.pertinance-label').remove();
                // entry.item.append('<span class="pertinance-label">' + pertinanceKeywords[pertinanceLevel] + '</span>');
            });

            if (table.length && val) {
                table.addClass('table--search');
                if (data.reorder) table.addClass('table--reorder');
                table.find('.table__body').removeClass('tableauAlterne');
            } else {
                table.removeClass('table--search');
                if (data.reorder) table.removeClass('table--reorder');
                table.find('.table__body').addClass('tableauAlterne');
            }

            // Autoselect: si autoselect est activé et qu'une recherche est active,
            // changer l'élément sélectionné pour le plus pertinent si celui actuellement sélectionné n'est plus visible.
            const autoselect = data.autoselect || input.data('autoselect');
            if (autoselect && val) {
                const currentSelected = items.filter('.selected');
                const isSelectedVisible = currentSelected.length > 0 && currentSelected.filter(function () {
                    return $(this).css('display') !== 'none';
                }).length > 0;

                if (!isSelectedVisible) {
                    const bestEntry = pertinanceScores.find(entry =>
                        entry.score > 0
                        && entry.item.css('display') !== 'none'
                        && entry.item.attr('data-value')
                        && !entry.item.hasClass('title')
                        && !entry.item.hasClass('sectionTR')
                        && !entry.item.hasClass('table__row--title')
                    );

                    if (bestEntry && bestEntry.item.length) {
                        const bestItem = bestEntry.item;
                        bestItem.trigger('click');
                        if (!bestItem.hasClass('selected')) {
                            const tableEl = bestItem.closest('table');
                            tableEl.find('tr.selected').removeClass('selected');
                            bestItem.addClass('selected');
                            tableEl.trigger('change');
                        }
                    }
                }
            }

            // Gestion de l'affichage lorsqu'aucun résultat n'est trouvé
            const tbody = table.find('.table__body').length ? table.find('.table__body') : (table.find('tbody').length ? table.find('tbody') : table);
            let noResultsRow = target.find('.table__row--no-results');
            let noResultsDiv = target.find('.table__empty--search');

            if (val && matchCount === 0 && items.length > 0) {
                const noResultsText = (data && (data.empty || data.noResults || data.emptyMessage))
                    || target.data('empty')
                    || target.attr('data-empty')
                    || (typeof __ === 'function' ? __('Aucun résultat trouvé') : 'Aucun résultat trouvé');

                if (table.length && tbody.length) {
                    if (!noResultsRow.length) {
                        const headCols = table.find('thead th, thead td').length;
                        const rowCols = items.first().children('td').length;
                        const colSpan = headCols || rowCols || 1;

                        noResultsRow = $(`
                            <tr class="table__row table__row--no-results notice notice--info">
                                <td class="table__cell table__cell--no-results" colspan="${colSpan || 100}">
                                    ${noResultsText}
                                </td>
                            </tr>
                        `);
                        tbody.append(noResultsRow);
                    } else {
                        noResultsRow.find('.table__cell--no-results').html(noResultsText);
                    }

                    if (table.hasClass('table--reorder') || data.reorder) {
                        noResultsRow.css({
                            'display': 'flex',
                            'width': '100%',
                            'order': 0,
                            'justify-content': 'center',
                        });
                        noResultsRow.find('.table__cell--no-results').css({
                            'display': 'table-row',
                            'width': '100%',
                        });
                    } else {
                        noResultsRow.css({
                            'display': 'table-row',
                            'width': '100%',
                            'order': '',
                        });
                        noResultsRow.find('.table__cell--no-results').css({
                            'display': '',
                            'width': '100%',
                        });
                    }
                    noResultsRow.show();
                    if (noResultsDiv.length) noResultsDiv.hide();
                } else {
                    if (!noResultsDiv.length) {
                        noResultsDiv = $(`<div class="table__empty table__empty--search" style="text-align: center; padding: 20px 10px; opacity: 0.6; font-style: italic;">${noResultsText}</div>`);
                        target.append(noResultsDiv);
                    } else {
                        noResultsDiv.html(noResultsText);
                    }
                    noResultsDiv.show();
                    if (noResultsRow.length) noResultsRow.hide();
                }
            } else {
                if (noResultsRow.length) {
                    noResultsRow.remove();
                }
                if (noResultsDiv.length) {
                    noResultsDiv.remove();
                }
            }
        }
    },

    // Fournit un matcher compatible Select2 qui utilise la même logique
    select2Matcher(params, data) {
        // Build search terms from params.term (use same build function)
        const utils = inputs.fn.search._searchUtils;
        const rawTerm = (params && params.term) ? params.term : '';
        const searchTerms = utils.buildSearchTerms(rawTerm);

        return utils.select2MatchRecursive(params, data, searchTerms);
    },
};

// ----------------------------
// Hook original qui attache la recherche aux inputs
// ----------------------------
inputs.types.search = function (data, name, niceName, type, input, parent, inputWindow) {
    input.on('keyup change search input', function (event) {
        inputs.fn.search.filter(data, name, niceName, type, input, parent, inputWindow, event);
    });
    input.on('keyup', function (event) {
        debounce(name+'_search', function() {input.change()}, 200);
    });
    input.on('change', function (event) {
        debounce(name+'_search', null);
    });
    return data;
};